/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import CopyToClipboard from "react-copy-to-clipboard";
import { FlexContainer, SVGIcon, theme } from "@nordcloud/gnui";
import { SUCCESS_TEXT } from "~/constants";
import { showSimpleInfo } from "~/services/toast";
import { IconWrapper } from "~/views/externalIntegrations/components/Cost";

type Props = {
  text: string;
  secure?: boolean;
};

export function CopyText({ text, secure = false }: Props) {
  const copyTextElementStyle = {
    backgroundColor: theme.color.field.default,
    color: theme.color.text.text01,
    border: `1px solid ${theme.color.border.input}`,
    borderRadius: "4px",
    paddingLeft: "4px",
  };

  return (
    <div style={copyTextElementStyle}>
      <FlexContainer>
        <span style={{ paddingRight: theme.spacing.spacing01 }}>
          {secure ? "*".repeat(text.length) : text}
        </span>
        <CopyToClipboard
          text={text}
          onCopy={() => showSimpleInfo(SUCCESS_TEXT.copied)}
        >
          <IconWrapper
            css={{
              cursor: "pointer",
              backgroundColor: theme.color.field.default,
            }}
          >
            <SVGIcon name="copy" />
          </IconWrapper>
        </CopyToClipboard>
      </FlexContainer>
    </div>
  );
}
